import type styles from '../../styles';

import * as React from 'react';

import { action } from 'mobx';
import { inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';
import type HistoryStore from 'connect/web/src/stores/history-store';

import { Button } from '@material-ui/core';
import type { SearchType } from 'connect/web/src/stores/search-store';
import type SearchStore from 'connect/web/src/stores/search-store';

interface IProps extends WithStyles<typeof styles> {
  actionLabel: string;
  mode: SearchType;
  subTitle: string;

  historyStore?: HistoryStore;
  searchStore?: SearchStore;
}

@inject('historyStore', 'searchStore')
@observer
class Action extends React.Component<IProps> {
  render() {
    const { actionLabel, classes, subTitle } = this.props;

    const sub = !!subTitle ? <p className={classes.buttonSubtitle}>{subTitle}</p> : null;

    return (
      <div className={classes.heroAction}>
        {sub}
        <Button color="primary" variant="contained" onClick={this.onClick}>
          {actionLabel}
        </Button>
      </div>
    );
  }

  @action.bound
  private onClick(): void {
    const { mode, searchStore } = this.props;
    searchStore!.locationId = 'All';
    searchStore!.mode = mode;
    this.props.historyStore!.push('/book');
  }
}

export default Action;
